var global = require('../internals/global');
var setGlobal = require('../internals/set-global');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/shared-store.js
// module id = 228
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35